import { render, staticRenderFns } from "./BasePaymentRadioInput.vue?vue&type=template&id=74836888&scoped=true&"
import script from "./BasePaymentRadioInput.vue?vue&type=script&lang=js&"
export * from "./BasePaymentRadioInput.vue?vue&type=script&lang=js&"
import style0 from "./BasePaymentRadioInput.vue?vue&type=style&index=0&id=74836888&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74836888",
  null
  
)

export default component.exports